// Mirrors People::MatchPhotoChooser: the match's photo wins, the record keeps its own only when the
// match has none.
export const matchedAvatarUrl = ({currentUrl, matchUrl}) => matchUrl || currentUrl;

// A stored url can outlive its file, and the backend then counts the match as photoless.
export const onUnreachablePhoto = (url, fallback) => {
    if (!url) return;

    const probe = new Image();
    probe.onerror = fallback;
    probe.src = url;
};
